<template>
  <div>
    <v-progress-linear
      color="#128279"
      :value="value"
      rounded
      height="8"
      :buffer-value="bufferValue"
    />
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: Number,
      default: 0
    },
    bufferValue: {
      type: [String, Number],
      default: 100
    }
  }
}
</script>
